export interface IUnderground {
  /** Цвет линии **/
  lineColor: string;
  /** Название станции **/
  name: string;
  /** Время до метро строкой **/
  timeDisplay: string;
  /** Способ передвижения **/
  transportType: ETransportType;
  /** Тип метро для отрисовки правильной иконки **/
  undergroundType: EUndergroundType;
}

export enum ETransportType {
  /** Траснпортом **/
  Transport = 'transport',
  /** Пешком **/
  Walk = 'walk',
}

export enum EUndergroundType {
  /** Москва **/
  Mow = 'mow',
  /** Самара **/
  Smr = 'smr',
  /** Екатеринбург **/
  Ekb = 'ekb',
  /** Казань **/
  Kzn = 'kzn',
  /** Санкт-Петербург **/
  Spb = 'spb',
  /** Новосибирск **/
  Nsk = 'nsk',
  /** Нижний новгород **/
  NN = 'nn',
}
